import axios from 'axios'
import tokenService from './token'
import { createApiUrl } from '../config/api'

const baseUrl = createApiUrl('/api/accounts/favourites/')

const PAGE_SIZE = 100

// The endpoint is paginated. Walk the pages by number rather than following
// `next`, whose scheme/host can be wrong behind the Cloud Run proxy.
const retrieve = async () => {
    const favourites = []
    let page = 1
    while (true) {
        const res = await axios.get(baseUrl, {
            ...tokenService.getAuthHeader(),
            params: { page, page_size: PAGE_SIZE },
        })
        favourites.push(...res.data.results)
        if (!res.data.next) return favourites
        page += 1
    }
}

const create = async (obj) => {
    const res = await axios.post(baseUrl, obj, tokenService.getAuthHeader())
    return res.data
}

const destroy = async (id) => {
    const res = await axios.delete(`${baseUrl}${id}/`, tokenService.getAuthHeader())
    return res
}

const favouritesService = { retrieve, create, destroy }

export default favouritesService
